import { render, staticRenderFns } from "./projectCard.vue.html?vue&type=template&id=c8ea9df0&"
import script from "./projectCard.ts?vue&type=script&lang=ts&"
export * from "./projectCard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports